import { useEffect } from "react";
import axios from "axios";
import texts from "../../texts";

function VisitorInfo() {
  useEffect(() => {
    const storageKey = "visitor-notification-sent";

    if (sessionStorage.getItem(storageKey)) return;

    let interacted = false;
    let waited = false;
    let sending = false;

    const events = ["pointerdown", "wheel", "touchstart", "keydown"];

    const removeListeners = () => {
      events.forEach((event) => {
        window.removeEventListener(event, handleInteraction);
      });
    };

    async function notifyVisitor() {
      if (
        !(
          interacted &&
          waited &&
          !sending &&
          document.visibilityState === "visible" &&
          !sessionStorage.getItem(storageKey)
        )
      ) {
        return;
      }

      sending = true;

      // Reserve this session before making requests to prevent duplicates.
      sessionStorage.setItem(storageKey, "pending");

      try {
        const response = await fetch("https://ipapi.co/json/");

        if (!response.ok) {
          throw new Error(`IP lookup failed: ${response.status}`);
        }

        const data = await response.json();

        if (data.error) {
          throw new Error(data.reason || "IP lookup failed");
        }

        const visitor = {
          ip: data.ip,
          city: data.city,
          region: data.region,
          country: data.country_name,
          countryCode: data.country_code,
          timezone: data.timezone,
          browser: navigator.userAgent,
          language: navigator.language,
          platform: navigator.platform,
          screen: `${window.screen.width}x${window.screen.height}`,
        };

        await axios.post(texts.contact.notificationURL, {
          name: "Samuel",
          email: `${visitor.city}, ${visitor.region}, ${
            visitor.country
          }, at ${new Date().toLocaleString()}`,
          subject: `New visit from ${visitor.city || "Unknown location"}`,
          message: JSON.stringify(visitor),
        });

        sessionStorage.setItem(storageKey, "sent");
        removeListeners();
      } catch (error) {
        sessionStorage.removeItem(storageKey);
        console.error("Could not send visitor notification:", error);
      } finally {
        sending = false;
      }
    }

    function handleInteraction(event) {
      if (!event.isTrusted) return;

      interacted = true;
      void notifyVisitor();
    }

    events.forEach((event) => {
      window.addEventListener(event, handleInteraction, { passive: true });
    });

    const timer = window.setTimeout(() => {
      waited = true;
      void notifyVisitor();
    }, 5000);

    return () => {
      window.clearTimeout(timer);
      removeListeners();
    };
  }, []);

  return null;
}

export default VisitorInfo;
